import Unlink16 from '@carbon/icons-react/es/unlink/16';
import { ColumnType } from 'antd/lib/table';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { JiraField } from 'api/integrations';
import { Menu } from 'components/atoms/dropdown/menu';
import { EmptyCell } from 'components/atoms/empty-cell/index';
import { MoreActionsDropdown } from 'components/atoms/more-actions';

type Data = {
  [key: string]: JiraField;
};

const Link = styled.a`
  color: var(--black-100);
  text-decoration: underline;
`;

const Text = styled.p`
  margin-bottom: 0px;
`;

type GenerateColumnProps = {
  issueUrl?: string;
  handleUnlink: () => void;
  handleDelete: () => void;
};

export const getColumns = ({
  issueUrl,
  handleDelete,
  handleUnlink,
}: GenerateColumnProps): ColumnType<Data>[] => {
  return [
    {
      dataIndex: 'issuetype',
      width: 32,
      render(issueType: JiraField) {
        if (!isEmpty(issueType)) {
          const { metaFieldValue } = issueType;

          if (!metaFieldValue) {
            return <EmptyCell />;
          }

          return <img src={metaFieldValue.iconUrl} alt="icon" />;
        }

        return <EmptyCell />;
      },
    },
    {
      title: <FormattedMessage id="summary" />,
      dataIndex: 'summary',
      width: 232,
      ellipsis: {
        showTitle: true,
      },
      render(summary: JiraField) {
        if (!isEmpty(summary)) {
          const { fieldValue } = summary;

          if (!fieldValue) {
            return <EmptyCell />;
          }

          return issueUrl ? (
            <Link href={issueUrl} target="_blank">
              {fieldValue}
            </Link>
          ) : (
            <Text>{fieldValue}</Text>
          );
        }

        return <EmptyCell />;
      },
    },
    {
      title: <FormattedMessage id="status" />,
      dataIndex: 'status',
      render(status: JiraField) {
        if (!isEmpty(status)) {
          if (status) {
            const { metaFieldValue, fieldValue = '' } = status;

            if (!metaFieldValue && !fieldValue) {
              return <EmptyCell />;
            }

            return <Text>{metaFieldValue?.name ?? fieldValue}</Text>;
          }
        }

        return <EmptyCell />;
      },
    },
    {
      title: <FormattedMessage id="priority" />,
      dataIndex: 'priority',
      render(priority: JiraField) {
        if (!isEmpty(priority)) {
          const { metaFieldValue } = priority;

          if (!metaFieldValue) {
            return <EmptyCell />;
          }

          return <Text>{metaFieldValue.name}</Text>;
        }

        return <EmptyCell />;
      },
    },
    {
      title: <FormattedMessage id="assigned_to" />,
      dataIndex: 'assignee',
      render(assignee: JiraField) {
        if (!isEmpty(assignee)) {
          const { metaFieldValue } = assignee;

          if (!metaFieldValue) {
            return <EmptyCell />;
          }

          return <Text>{metaFieldValue.displayName}</Text>;
        }

        return <EmptyCell />;
      },
    },
    {
      width: 40,
      render() {
        return (
          <MoreActionsDropdown
            className="more-actions"
            placement="bottomLeft"
            menu={
              <Menu>
                <Menu.Item
                  onClick={handleUnlink}
                  key="unlink"
                  icon={<Unlink16 />}
                >
                  <FormattedMessage id="task.unlink_jira_issue" />
                </Menu.Item>
                <Menu.ItemDelete onClick={handleDelete} key="delete">
                  <FormattedMessage id="task.delete_jira_issue" />
                </Menu.ItemDelete>
              </Menu>
            }
          />
        );
      },
    },
  ];
};
